export const rectificationResultOption={
    column: [
      {
        type: 'textarea',
        label: '整改意见',
        span: 24,
        display: true,
        formslot:true,
        prop: 'confirmDesc',
        required: true,
        rules: [
          {
            required: true,
            message: '整改意见必须填写'
          }
        ]
      },
      {
        type: 'select',
        label: '验收人',
        cascaderItem: [],
        span: 8,
        display: true,
        dicUrl: '/api/v4ward/user/userList',
        props: { label: 'realName', value: 'id' },
        prop: 'confirmManId',
        required: true,
        rules: [
          {
            required: true,
            message: '请选择验收人'
          }
        ]
      },
      {
        type: 'input',
        label: '附件',
        span: 24,
        formslot:true,
        display: true,
        prop: 'attachList'
      }
    ],
    labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 100,
    gutter: 0,
    menuBtn: true,
    submitBtn: true,
    submitText: '提交',
    emptyBtn: false,
    emptyText: '清空',
    menuPosition: 'center',
    detail: false,
    tabs: false
  }


  export const noticeFormOption = {
    column: [
      {
        label:'整改单位',
        type: 'input',
        span: 24,
        display: true,
        dicOption: 'static',
        props: {
          label: 'label',
          value: 'value'
        },
        prop: 'rectifyUnit',
        required: true,
        rules: [
          {
            required: true,
            message: '整改单位必须填写'
          }
        ],
        maxlength: 40,
        showWordLimit: true
      },
      {
        type: 'input',
        label: '责任人',
        span: 24,
        display: true,
        dicOption: 'static',
        props: {
          label: 'label',
          value: 'value'
        },
        prop: 'rectifyMan',
        rules: [],
        maxlength: 40,
        showWordLimit: true
      },
      {
        type: 'date',
        label: '完成时间',
        span: 24,
        display: true,
        format: 'yyyy-MM-dd',
        valueFormat: 'yyyy-MM-dd HH:mm:ss',
        prop: 'endTime',
        required: true,
        rules: [
          {
            required: true,
            message: '整完成时间必须填写'
          }
        ]
      },
      {
        type: 'textarea',
        label: '整改要求',
        span: 24,
        display: true,
        prop: 'rectifyDesc',
        required: true,
        rules: [
          {
            required: true,
            message: '整改要求必须填写'
          }
        ],
        maxlength: 500,
        showWordLimit: true
      }
    ],
    labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 100,
    gutter: 0,
    menuBtn: true,
    submitBtn: true,
    submitText: '提交',
    emptyBtn: true,
    emptyText: '清空',
    menuPosition: 'center',
    detail: false,
    tabs: false
  }
